import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { FormController, MuiGrid, MuiTextField } from "../../../../components";
import {
  gridSizeLongLabel,
  MAX_LENGTH_1000,
  PAGE_IDS,
} from "../../../../helpers/constants";
import { useGridContainer } from "../../../../hooks/useGridContainer";
import { useNavigationSiteCore } from "../../../../hooks/useNavigationSiteCore";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { MdmCreateOfficeFormKeys } from "../../modelsAndSchemas/models";
import { mdmCreateOfficeSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { InvoicingDetailsWrapper } from "./InvoicingDetails.style";

const pageId = PAGE_IDS.MDM_INVOICING_DETAILS;

export const InvoicingDetails: FC = () => {
  const { useFetchLabel, commonLabels } = useSiteCore();
  const { control } = useFormContext();
  const { commonARIALabel } = useNavigationSiteCore();

  const { gridSizeMediumClass } = useGridContainer(true);

  const { createNewOfficeTitle, header, footerOne, footerTwo, footerThree } =
    mdmCreateOfficeSiteCoreKeys;

  const getLabel = useFetchLabel(createNewOfficeTitle);

  return (
    <InvoicingDetailsWrapper>
      <MuiGrid container>
        <MuiGrid className={gridSizeMediumClass} size={gridSizeLongLabel}>
          <FormController
            control={control}
            name={MdmCreateOfficeFormKeys.header}
          >
            <MuiTextField
              isMandatory
              id={`${pageId}-${MdmCreateOfficeFormKeys.header}`}
              label={getLabel(header)}
              placeholder={commonLabels.inputPlaceHolder}
              className="notes-input"
              multiline
              maxLength={MAX_LENGTH_1000}
              rows={4}
              data-testId={`${pageId}-${MdmCreateOfficeFormKeys.header}`}
              requiredARIALabel={commonARIALabel.required}
            />
          </FormController>
        </MuiGrid>
        <MuiGrid className={gridSizeMediumClass} size={gridSizeLongLabel}>
          <FormController
            control={control}
            name={MdmCreateOfficeFormKeys.footer1}
          >
            <MuiTextField
              id={`${pageId}-${MdmCreateOfficeFormKeys.footer1}`}
              label={getLabel(footerOne)}
              placeholder={commonLabels.inputPlaceHolder}
              className="notes-input"
              multiline
              maxLength={MAX_LENGTH_1000}
              rows={4}
              data-testId={`${pageId}-${MdmCreateOfficeFormKeys.footer1}`}
              requiredARIALabel={commonARIALabel.required}
            />
          </FormController>
        </MuiGrid>

        <MuiGrid className={gridSizeMediumClass} size={gridSizeLongLabel}>
          <FormController
            control={control}
            name={MdmCreateOfficeFormKeys.footer2}
          >
            <MuiTextField
              id={`${pageId}-${MdmCreateOfficeFormKeys.footer2}`}
              label={getLabel(footerTwo)}
              placeholder={commonLabels.inputPlaceHolder}
              className="notes-input"
              multiline
              maxLength={MAX_LENGTH_1000}
              rows={4}
              data-testId={`${pageId}-${MdmCreateOfficeFormKeys.footer2}`}
              requiredARIALabel={commonARIALabel.required}
            />
          </FormController>
        </MuiGrid>

        <MuiGrid className={gridSizeMediumClass} size={gridSizeLongLabel}>
          <FormController
            control={control}
            name={MdmCreateOfficeFormKeys.footer3}
          >
            <MuiTextField
              id={`${pageId}-${MdmCreateOfficeFormKeys.footer3}`}
              label={getLabel(footerThree)}
              placeholder={commonLabels.inputPlaceHolder}
              className="notes-input"
              multiline
              maxLength={MAX_LENGTH_1000}
              rows={4}
              data-testId={`${pageId}-${MdmCreateOfficeFormKeys.footer3}`}
              requiredARIALabel={commonARIALabel.required}
            />
          </FormController>
        </MuiGrid>
      </MuiGrid>
    </InvoicingDetailsWrapper>
  );
};
